import { AssetWithId } from 'base/asset';
import { addPromiseToCache, CacheState } from 'base/library_cache';
import { BlocksService } from 'blocks/blocks_service';
import { observable } from 'mobx';

export class ProjectAssetStore {
  constructor(
    private readonly blocksService: BlocksService,
    private readonly projectToken: string,
  ) {}

  private assetCache = observable.map<string, CacheState<AssetAPI | null>>();

  getProjectImage(assetId: number): CacheState<AssetAPI | null> {
    const key = `${assetId}`;
    if (this.assetCache.has(key)) {
      return this.assetCache.get(key)!;
    }

    return addPromiseToCache(
      this.assetCache,
      key,
      this.blocksService
        .getImages(this.projectToken, [assetId])
        .then(({ assets }) => new AssetAPI(assets[0]) ?? null),
    );
  }

  async uploadProjectImage(file: File) {
    const {
      assets: [asset],
    } = await this.blocksService.uploadImage(this.projectToken, file);

    const value = new AssetAPI(asset);

    this.assetCache.set(`${asset.id}`, {
      type: 'fulfilled',
      value,
      promise: Promise.resolve(value),
    });

    return value;
  }
}

class AssetAPI {
  constructor(private readonly asset: AssetWithId) {}

  get id() {
    return this.asset.id;
  }

  get width() {
    return this.asset.width;
  }

  get height() {
    return this.asset.height;
  }

  // Image sizes available are [160, 320, 640, 1280, 2560].
  // These variants are defined in the backend (asset/views.py) and generated by
  // Cloudflare Images.

  get fullSizeUrl() {
    return this.asset.files[4].url;
  }

  get thumbnailUrl() {
    return this.asset.files[0].url;
  }
}
